import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkDataOverallMultimediaForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsLinkDataOverallMultimedia = ({
  editable = true,
  forceValidation,
  overallMultimediaChange,
  overallMultimediaLinkData,
  overallMultimediaLinkMetadata,
  overallMultimediaValidate,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.overallMultimedia.title')}</h3>
    <LinkDataOverallMultimediaForm
      editable={editable}
      forceValidation={forceValidation}
      onChange={overallMultimediaChange}
      onValidate={overallMultimediaValidate}
      overallMultimediaLinkData={overallMultimediaLinkData}
      overallMultimediaLinkMetadata={overallMultimediaLinkMetadata}
      shouldIgnoreMandatoryValidation
    />
  </>
);

export default IncidentDetailsLinkDataOverallMultimedia;
